import { TextFilterProps } from '@progress/kendo-react-data-tools'
import { useAppSelector } from 'store'

import { MultiSelectFilter } from '../MultiSelectFilter'

export const PaymentProviderFilter: React.FC<TextFilterProps> = (props) => {
  const { filter, onFilterChange } = props
  const paymentProviderTypes = useAppSelector((state) => state.transactions.paymentProviders)
  const data = paymentProviderTypes.map((x) => ({ id: x.id, label: x.name, value: x.id }))

  return (
    <MultiSelectFilter
      placeholder='Payment Provider'
      filter={filter}
      onFilterChange={onFilterChange}
      data={data}
      style={{ width: '27.5rem' }}
    />
  )
}
